/** Shared motion constants so every section moves with one voice. */
export const EASE = [0.16, 1, 0.3, 1] as const;

export const SPRING = { type: 'spring', stiffness: 120, damping: 20 } as const;

/** Standard scroll-reveal: fade + short rise. */
export const reveal = {
  hidden: { opacity: 0, y: 26 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: EASE },
  },
};

/** Container that staggers its children on view. */
export const stagger = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};
